
import { NotificationContent } from '@/utils/notification.util';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'MintArenaNotificationContent',
  props: {
    infoElements: {
      type: Array as PropType<NotificationContent[]>,
      required: true
    }
  },
  setup (props) {
    return {
      infoElements: props.infoElements
    }
  }
});
